import IBAN from 'iban';
import maxLength from '../maxLength';
import minLength from '../minLength';
/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR = 'invalid_iban';
var min = minLength(20);
var max = maxLength(24);
/**
 * Creates validator for iban ES
 *
 * @function ibanEs
 * @return {validator} ibanEs validator
 */

export default function ibanEs() {
  return function (value) {
    // eslint-disable-next-line no-param-reassign
    value = value.replace(/(\s|-)/gi, '');
    if (min(value)) {
      return min(value);
    }
    if (max(value)) {
      return max(value);
    }
    if (value && !(IBAN.isValidBBAN('ES', value) || IBAN.isValid(value))) {
      return ERROR;
    }
    return null;
  };
}